import isApiError from "@insite/client-framework/Common/isApiError";

/**
 * IEIXOP-6930: Marker set on carrier-rating failures handled by Checkout Shipping
 * so HandleError skips the generic Unhandled Error modal for that request only.
 */
export const CHECKOUT_SHIPPING_HANDLED_ERROR = "handledByCheckoutShipping";

/** IEIXOP-6930: Detects cart PATCH failures like "No carriers processed.. State: ..., Postal Code: ...". */
export const isNoCarriersProcessedError = (error: unknown): boolean => {
    if (!error || typeof error !== "object") {
        return false;
    }

    const apiError = error as {
        status?: number;
        errorMessage?: string;
        message?: string;
        errorJson?: { message?: string };
    };

    if (apiError.status !== 400 && !isApiError(error)) {
        return false;
    }

    const message = `${apiError.errorJson?.message || apiError.errorMessage || apiError.message || ""}`;
    return message.toLowerCase().includes("no carriers");
};
